import React, { useRef } from 'react';
import classNames from 'classnames';
import { useHover } from 'usehooks-ts';
import type { MapHotelCardProps } from './types';
import HotelCardFeatures from './components/HotelCardFeatures';
import HotelCardLabels from './components/HotelCardLabels';
import HotelCardPriceBlock from './components/HotelCardPriceBlock';
import HotelCardGalleryOverlay from './components/HotelCardGalleryOverlay';
import HotelCardMapTitleBlock from './components/HotelCardMapTitleBlock';
import { HOTEL_CARD_TEST_ID } from './constants';
import styles from './mapHotelCard.module.css';

const MapHotelCard: React.FC<MapHotelCardProps> = (props) => {
  const {
    id,
    images,
    bonusCount,
    currencyCode,
    hotelPageVisited,
    stars,
    hotelName,
    hotelLocation,
    rating,
    cashbackIdentifier,
    customCashbackIconURL,
    customCashbackText,
    customCashbackTooltipText,
    features,
    instantConfirm,
    price,
    innerLabels,
    isHotelOnly,
    availability,
    hotelPageHref,
    openInCurrentTab,
    onCloseIconClick,
    className,
  } = props;

  const cardRef = useRef<HTMLDivElement>(null);
  const isCardHovered = useHover(cardRef);

  return (
    <div
      ref={cardRef}
      data-testid={HOTEL_CARD_TEST_ID}
      className={classNames(styles.cardContainer, className)}
    >
      <div className={styles.cardContent}>
        <div className={styles.galleryContainer}>
          <HotelCardGalleryOverlay
            id={id}
            price={price}
            images={images}
            isMobile={false}
            bonusCount={bonusCount}
            currencyCode={currencyCode}
            hotelPageVisited={hotelPageVisited}
            stars={stars}
            hotelName={hotelName}
            hotelLocation={hotelLocation}
            rating={rating}
            cashbackIdentifier={cashbackIdentifier}
            customCashbackIconURL={customCashbackIconURL}
            customCashbackText={customCashbackText}
            customCashbackTooltipText={customCashbackTooltipText}
            hotelPageHref={hotelPageHref}
            openInCurrentTab={openInCurrentTab}
            isMapCard
          />
        </div>

        <div className={styles.hotelInfo}>
          <div>
            <HotelCardMapTitleBlock
              id={id}
              price={price}
              stars={stars}
              hotelName={hotelName}
              hotelLocation={hotelLocation}
              hotelPageHref={hotelPageHref}
              openInCurrentTab={openInCurrentTab}
              onCloseIconClick={onCloseIconClick}
            />
            <HotelCardFeatures isMobile={false} features={features} />
            <HotelCardLabels isMobile={false} labels={innerLabels} />
          </div>
          <HotelCardPriceBlock
            instantConfirm={instantConfirm}
            isFlexDates={false}
            isMapCard
            price={price}
            currencyCode={currencyCode}
            availability={availability}
            isHotelOnly={isHotelOnly}
            isCardHovered={isCardHovered}
            hotelPageHref={hotelPageHref}
            openInCurrentTab={openInCurrentTab}
          />
        </div>
      </div>
    </div>
  );
};

export default MapHotelCard;
